import axios from "axios";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { BaseUrl } from "../../App";

export default function PaymentResult() {
  const navigate = useNavigate();

  useEffect(() => {
    async function handlePaymentResult() {
      const query = new URLSearchParams(window.location.search);

      const success =
        query.get("success") ||
        query.get("status") ||
        query.get("txn_response_code");

      const isSuccess =
        success === "true" ||
        success === "TRUE" ||
        success === "APPROVED" ||
        success === "SUCCESS" ||
        success === "1";

      const cartId = localStorage.getItem("cartId");

      // ✅ send order once
      // if (isSuccess && cartId && !localStorage.getItem("orderSent")) {
      //   try {
      //     await axios.post(
      //       `${BaseUrl}user/send-order`,
      //       {
      //         cart_id: cartId,
      //         payment_methode: "visa",
      //         source: "web",
      //       },
      //       {
      //         headers: {
      //           Authorization: `Bearer ${localStorage.getItem("token")}`,
      //           Accept: "application/json",
      //         },
      //       }
      //     );

      //     localStorage.setItem("orderSent", "true"); // 🔥 يمنع التكرار
      //   } catch (err) {
      //     console.log("Order error:", err.response?.data);
      //   }
      // }

      // ✅ UI
      if (isSuccess) {
        Swal.fire({
          title: "تم الدفع بنجاح 🎉",
          text: "شكراً لطلبك ✔️",
          icon: "success",
          confirmButtonText: "عرض الطلبات",
        }).then(() => {
          localStorage.removeItem("cartId");
          localStorage.removeItem("orderSent");
          navigate("/confirmedorders");
        });
      } else {
        Swal.fire({
          title: "فشل الدفع ❌",
          text: "حاول مرة أخرى",
          icon: "error",
          confirmButtonText: "الرجوع للسلة",
        }).then(() => {
          navigate("/cart");
        });
      }
    }

    handlePaymentResult();
  }, [navigate]);

  return (
    <h2 className="text-center mt-5">
      جاري التحقق من الدفع...
    </h2>
  );
}